export function downloadFile(blob: Blob, fileName: string) {
  const element = document.createElement('a');

  element.href = window.URL.createObjectURL(blob);
  element.download = fileName;
  document.body.appendChild(element);

  element.click();

  element.remove();
}
